const angularModule = angular.module('com.comtrade.shared.ctxGrid', [
]);

angularModule.directive('ctxGrid', require('./ctxGrid.directive'));
angularModule.directive('ctxGridColumn', require('./ctxGridColumn.directive'));
angularModule.directive('ctxGridPreRow', require('./ctxGridPreRow.directive'));
angularModule.directive('ctxGridPostRow', require('./ctxGridPostRow.directive'));
angularModule.directive('ctxGridCellRenderer', require('./ctxGridCellRenderer.directive'));
angularModule.directive('ctxGridPrePostRowRenderer', require('./ctxGridPrePostRowRenderer.directive'));
angularModule.directive('ctxGridSetTableBodyHeight', require('./ctxGridSetTableBodyHeight.directive.js'));

module.exports = angularModule;



// WEBPACK FOOTER //
// ./src/shared/ctxGrid/ctxGrid.module.js